module.exports = __webpack_public_path__ + "static/media/民眾相信的臨震保命策略vs臨震反應.c41b1810.png";